import { SET_CONFIGS } from './ConfigsActionType.js';

function setConfigs(configs) {
    return { type: SET_CONFIGS, configs };
}

export { setConfigs };
